import { programMonitoringPeriodsQueryOptions } from '../../../hooks/data/useProgramMonitoringPeriods'
import { queryClient } from '../../../queryClient'

export async function getAvailableProgramMonitoringPeriods({ values }: { values: number }) {
  // fetchQuery for the same reason as getMonitoringSites: an invalidated entry must be re-read.
  const programMonitoringPeriods = await queryClient.fetchQuery(
    programMonitoringPeriodsQueryOptions({ programId: values }),
  )
  return programMonitoringPeriods.map(period => ({
    id: period.id,
    label: period.name,
  }))
}
